import { Document, Page } from '@react-pdf/renderer';

import ListOfEnclosure from '../../pdfForms/HighSchool/HSListOfEnclosure';
import FormAP1 from '../../pdfForms/PensionFormA';
import FormBP1 from '../../pdfForms/FormB/PensionFormBPart1';
import FormBP2 from '../../pdfForms/FormB/PensionFormBPart2';
import FormBP3 from '../../pdfForms/FormB/PensionFormBPart3';

import PensionLastPayCertificate from '../../pdfForms/certificates/PensionLastPayCertificate';
import SpecimanSignature from '../../pdfForms/PensionSpecimanSignature';
import Thumb from '../../pdfForms/PensionThumb';
import FamilyDetails from '../../pdfForms/PensionDetailsofFamily';
import Declaration from '../../pdfForms/PensionDeclaration';
import NoDueCertificate from '../../pdfForms/certificates/NoDuesCertificate';

import Form1 from '../../pdfForms/PensionApprndixV';

import AnnexureA from '../../pdfForms/PensionAnnexure/PensionAnnexure';
import AnnexureA2 from '../../pdfForms/PensionAnnexure/PensionAnnexure2';
import AnnexureII from '../../pdfForms/HighSchool/pensionAnnexure2';

import Form6P1P1 from '../../pdfForms/Form6/PensionForm6P1P1';
import Form6P1P2 from '../../pdfForms/Form6/PensionForm6P1P2';
import Form6P1P3 from '../../pdfForms/Form6/PensionForm6P1P3';
import Form6P2P1 from '../../pdfForms/Form6/PensionForm6P2S1';
import Form6P2P2 from '../../pdfForms/Form6/PensionForm6P2S2';

import Form7 from '../../pdfForms/PensionForm7';


import RoughCalculation from '../../pdfForms/roughCalculation/PensionRoughCalculation';
import RoughCalculation2 from '../../pdfForms/roughCalculation/PensionRoughCalculation2';
import ServiceHistory from '../../pdfForms/pensionServiceHistory';
import Break from '../../pdfForms/pensionBreak'

import SchoolLetter from '../../pdfForms/HighSchool/page1'
import Form15A from '../../pdfForms/HighSchool/pensionForm15A'
import Form15P2 from '../../pdfForms/HighSchool/pensionForm15P2'
import Form15 from '../../pdfForms/HighSchool/pensionForm15P1'

import CertificateHS from '../../pdfForms/HighSchool/pensionCertificate';
import Vacation from '../../pdfForms/HighSchool/pensionVacations'
import GrantableCertificate from '../../pdfForms/HighSchool/pensionGrantableCertificate'
import ConsentForm from '../../pdfForms/HighSchool/pensionConsentForm'
import NonEmpCer from '../../pdfForms/HighSchool/pensionNonEmpCer'
import ShaleyPatra from '../../pdfForms/HighSchool/pensionShaleyPatra'
import GenralCertificate from '../../pdfForms/HighSchool/pensionGeneralCerti'
import ServiceCertificate from '../../pdfForms/certificates/ServiceCetificate';

const MyDocument = ({ result }) => (
  
  <Document>
     <Page size="A4">
      <ListOfEnclosure result={result}/>
    </Page>

    <Page size="A4">
      <AnnexureA result={result}/>
    </Page>
     <Page size="A4">
      <AnnexureA2 result={result}/>
    </Page>

    <Page size="A4">
      <Form7 result={result}/>
    </Page>

  {/* Form A */}  
    <Page size="A4">
      <FormAP1  result={result}/>
    </Page>

{/* Form B */}
  <Page size="A4">
      <FormBP1 result={result}/>
    </Page>
    <Page size="A4">
      <FormBP2 result={result}/>
      <FormBP3 result={result}/>
    </Page>

  {/* Form 5 */}
    <Page size="A4">
        <Form5 result={result}/>
      </Page>
      


 <Page size="A4">
      <SpecimanSignature result={result}/>
    </Page>

    <Page size="A4">
      <Thumb result={result}/>
    </Page>

    <Page size="A4">
      <FamilyDetails result={result}/>
    </Page>

{/* Form 6 */}
    <Page size="A4">
      <Form6P1P1 result={result}/>
    </Page>
    <Page size="A4">
      <Form6P1P2 result={result}/>
    </Page>
    <Page size="A4">
      <Form6P1P3 result={result}/>
    </Page>
    <Page size="A4">
      <Form6P2P1 result={result}/>
    </Page>
    <Page size="A4">
      <Form6P2P2 result={result}/>
    </Page>

{/* Form 1 */}
    <Page size="A4">
      <Form1 result={result}/>
    </Page>

{/* Last Pay Certificate */}
    <Page size="A4">
      <PensionLastPayCertificate result={result}/>
    </Page>

{/* Rough Calculation */}
    <Page size="A4">
      <RoughCalculation result={result}/>
    </Page>


  <Page size="A4">
     <RoughCalculation2 result={result}/>
  </Page>

  
  {/* Certificates */}
  <Page size="A4">
      <NoDueCertificate result={result}/>
    </Page>

   <Page size="A4">
      <Declaration result={result}/>
    </Page>

    <Page size="A4">
      <ServiceCertificate result={result}/>
    </Page>

  <Page size="A4">
      <GrantableCertificate result={result}/>
    </Page>




   <Page size="A4" orientation='landscape'>
      <ServiceHistory result={result}/>
    </Page>

    <Page size="A4" orientation='landscape'>
      <Break result={result}/>
    </Page>

{/* Source of pay drawn */}


    <Page size="A4">
      <ConsentForm result={result}/>
    </Page>

    <Page size="A4">
      <CertificateHS result={result}/>
    </Page>

   <Page size="A4">
      <Vacation result={result}/>
    </Page>

    <Page size="A4">
      <ShaleyPatra result={result}/>
    </Page>

    <Page size="A4">
      <GenralCertificate result={result}/>
    </Page>





    
    
    
    
    
    
    
    
    
    
    <Page size="A4">
      <SchoolLetter result={result}/>
    </Page>

    {/* <Page size="A4">
      <Form15A result={result}/>
    </Page>
   */}



    <Page size="A4">
      <Form15 result={result}/>
    </Page>

    <Page size="A4">
      <Form15P2 result={result}/>
    </Page>

   <Page size="A4">
      <AnnexureII result={result}/>
    </Page>
 
  <Page size="A4">
      <NonEmpCer result={result}/>
    </Page>


  </Document>
);

export default MyDocument;